import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { OutlinedInput, MenuItem, Chip, Stack } from '@mui/material';
import { useGetUsersQuery, useUpdateUserMutation } from '../../features/users/usersApiSlice';
import { useGetdesignationsQuery } from '../../features/designations/designationApiSlice';
import { useGetofficetypeQuery } from '../../features/officetype/officetypeApiSlice';
import { useGetStoreOfficesQuery, useUpdateStoreOfficeMutation } from '../../features/storeoffices/storeofficesApiSlice';
import { useGetrolesQuery } from '../../features/roles/rolesApiSlice';
import { useGetdesignationsuffixQuery } from '../../features/designationsuffix/designationSuffixApiSlice';
import { useGetofficesQuery, useUpdateofficeMutation } from '../../features/offices/officesApiSlice';
import { useLazyGetFilteredAssetRequestsQuery, useUpdateassetReqMutation } from '../../features/assetrequest/assetReqApiSlice';
import { useLazyGetFilteredConsumableRequestsQuery, useUpdateConsumableReqMutation } from '../../features/consumablerequest/consumableReqApiSlice';
import { useLazyGetFilteredComplaintsLazyQuery, useUpdateComplaintsMutation } from '../../features/complaints/complaintsApiSlice';
import { useIsMount } from '../../features/hooks/useIsMount';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Typography from '@mui/material/Typography';
import calNumSuffix from '../../data/numSuffix';
import FilteredAssetsFetcher from '../Assets/Myasset/FilteredAssetsFetcher';
import { useCheckAssetMatchMutation } from '../../features/addassets/addassetApiSlice';
import useAuth from '../../features/hooks/useAuth';
import terminateUserRequests from './terminateUserRequests';


const USER_REGEX = /^[A-z][A-z0-9-_]{1,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const MOBILE_REGEX = /^[0]?[789]\d{9}$/;
const EMPID_REGEX = /^[0-9]+$/;
const LANDLINE_REGEX = /^[0]\d{10}$/;
const OFFICEADD_REGEX = /.$/;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EditUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #5C5891;
`;
const EditFieldButton = styled.button`
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  height: 35px;
  padding: 6px 16px;
  border-radius: 4px;
  border-width: 0;
  background-color: #5C5891;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin-left: 20px;
  color: #fff;
`;

const UserEmailWrapper = styled.div`
  margin-left: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
  min-height: 75px;
`;
const EditOptionsWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 30px;
`;
const FlexWrapper = styled.div`
  display: flex;
`;

const ValidationTextDiv = styled.div`
  color: red;
`;

const LabelInputWrapper = styled.div`
  margin-bottom: 25px;
  flex: 1 0 30%;
  display: ${(props) => props.disp};
`;
const LabelInputWrapperSuffix = styled.div`
  margin-right: 30px;
  margin-bottom: 25px;
`;
const OfficeWiseRolesSubWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const SuffixWrapper = styled.div`
  display: flex;
  margin: 20px;
`;
const DesignationWrapper = styled.div`
  display: flex;
  margin: 20px;
`;
const DesignationWithOffice = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: center; */
  margin-left: 20px;
  margin-bottom: 20px;
`;
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom: 20px;
`;
const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #5C5891;
`;

const Button = styled.button`
  height: 25px;
`;
const Adduserformcont = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
`;
const Chrg = styled.div`
  display: flex;
  align-items: left;
  margin: 20px;
`;
const AddChrgWrapper = styled.div`
  display: flex;
  margin-left: 30px;
`;
const BoRolesWrapper = styled.div`
  display: flex;
`;
const MainRolesWrapper = styled.div`
  display: flex;
  margin: 20px;
`;
const RolesWrapper = styled.div`
`;
const OfficeWiseRolesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 0 30%;
  row-gap: 20px;
  column-gap: 20px;
  margin: 20px;
  align-items: center;
`;

const MainChrgWrapper = styled.div`
  display: flex;
`;

const mainRoles = [
  'Admin',
  'SuperAdmin'
]
const Fields = [
  'All',
  'Name',
  'Password',
  'Contact Number',
  'Employee ID',
  'Office Address',
  'Office',
  'Designation',
  'Roles'
]

const otherRoles = [
  'Bo'  
]

const storeRoles = [
"ItemAdder_A",
"L1Approver_A",
"L2Approver_A",
"L1ReqApprover_A",
"L2ReqApprover_A",
"ItemAdder_C",
"L1Approver_C",
"L2Approver_C",
"L1ReqApprover_C",
"L2ReqApprover_C",
"L1Support",
"L2Support"
]

// Check if the two Arrays are identical
const areArraysIdentical = (array1, array2) => {
  // Check if arrays have the same length
  if (array1?.length !== array2?.length) {
    return false;
  }
  // Check if each element in both arrays is identical
  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }
  // If all elements are identical, return true
  return true;
};

const EditUsers = () => {
  // Helper function to check if user has admin privileges
  const hasAdminAccess = () => {
    return Auth.roles?.main?.includes("Admin") || Auth.roles?.main?.includes("SuperAdmin");
  };

  // Helper function to get current user's offices (main charge + additional charge)
  const getCurrentUserOffices = () => {
    return [Auth.office?.mainCharge, ...(Auth.office?.additionalCharge || [])].filter(Boolean);
  };

  // Helper function to check if an office is a store office
  const isOfficeStoreOffice = (officeName) => {
    return Object.values(storeoffices)?.some(x => x.storeoffice === officeName);
  };

  /*
   * ACCESS CONTROL RULES:
   * 1. Admin/SuperAdmin: Can edit any user from any office
   * 2. Regular Users: Can only edit users who belong to their office(s)
   *    - Main charge office
   *    - Additional charge offices
   * 3. All users can only access "Other Roles (Office Wise)" section
   * 4. Admin/SuperAdmin can access all sections including "Main Roles"
   * 5. Store roles are only available for offices that are actually store offices
   */

  let initialUserState = {
    id: "",
    name: { firstName: "", middleName: "", lastName: "" },
    email: "",
    mobileNo: "",
    officeLandLine: "",
    employeeID: "",
    officeAddress: "",
    office: { mainCharge: "", additionalCharge: [] },
    designation: {},
    designationSuffix: {},
    numSuffix: {},
    roles: { main: ["user"] },
    active: true
  };

  let initialValue = {
    additionalCharge: [],
    desig: null,
    officeForDesgn: null,
    desgnSuffix: null,
    officeForSuffix: null,
    selectFieldsToEdit: []
  };
  const userRef = useRef();
  const Auth = useAuth();  

  const [validFirstName, setValidFirstName] = useState(false);
  const [firstNameFocus, setFirstNameFocus] = useState(false);

  const [validMiddleName, setValidMiddleName] = useState(false);
  const [middleNameFocus, setMiddleNameFocus] = useState(false);

  const [validLastName, setValidLastName] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);

  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [validMobile, setValidMobile] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);

  const [validLandline, setValidLandline] = useState(false);
  const [landlineFocus, setLandlineFocus] = useState(false);

  const [validEmpId, setValidEmpId] = useState(false);
  const [empIDFocus, setEmpIdFocus] = useState(false);

  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);


  const [validOfficeAdd, setValidOfficeAdd] = useState(false);
  const [officeAddFocus, setOfficeAddFocus] = useState(false);

  const [currentUser, setCurrentUser] = useState(initialUserState);
  const [originalUser, setOriginalUser] = useState(initialUserState);
  const [showPassword, setShowPassword] = useState(false);
  const [editableuser, setEditableUser] = useState({})
  const [editFields, setEditFields] = useState([]);
  const [desig, setDesig] = useState([]);
  const [offices, setOffices] = useState([]);
  const [officeType, setOfficeType] = useState();
  const [value, setValue] = useState(initialValue);
  const [storeOffices, setStoreOffices] = useState();
  const [fieldRender, setFieldRender] = useState(false);
  const [userData, setUserData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [filters, setFilters] = useState({
    perm_cur_store: [],
    perm_alloc_ofc: [],
    perm_alloc_user: [],
    perm_ids: [],
    perm_cur_loc: [],
    perm_name: [],
  });
  
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const {user} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
        user: data?.entities
    }),
  })

  const [updateUser, {
    isLoading: updateuserisLoading,
    isSuccess: updateuserisSuccess,
    isError: updateuserisError,
    error: updateuserErrorS
  }] = useUpdateUserMutation();

  const [checkAssetMatch, { 
    data, 
    isLoading, 
    isError, 
    error 
  }] = useCheckAssetMatchMutation();

  const [updateOffice] = useUpdateofficeMutation();
  const [updateStoreOffice] = useUpdateStoreOfficeMutation();

  // RTK Query hooks for request termination
  const [getFilteredAssetRequests] = useLazyGetFilteredAssetRequestsQuery();
  const [updateAssetReq] = useUpdateassetReqMutation();
  const [getFilteredConsumableRequests] = useLazyGetFilteredConsumableRequestsQuery();
  const [updateConsumableReq] = useUpdateConsumableReqMutation();
  const [getFilteredComplaints] = useLazyGetFilteredComplaintsLazyQuery();
  const [updateComplaints] = useUpdateComplaintsMutation();


  const {officedata} = useGetofficesQuery("officeList", {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  })

  const {officetype} = useGetofficetypeQuery("officeTypeList", {
    selectFromResult: ({ data }) => ({
      officetype: data?.entities
    }),
  })

  const {designationsuffix}= useGetdesignationsuffixQuery("desigsuffix", {
    selectFromResult: ({ data }) => ({
      designationsuffix: data?.entities
    }),
  })
  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })

  const {designation} = useGetdesignationsQuery("designations", {
    selectFromResult: ({ data }) => ({
        designation: data?.entities
      }),
  })

  // Set filters when ID changes
  useEffect(() => {
    if (currentUser?.id) {
      setFilters({
        perm_alloc_ofc: [],
        perm_cur_loc: [],
        perm_cur_store: [],
        perm_alloc_user: [currentUser?.id],
        perm_ids: [],
        perm_name: [],
      });
    } else {
      setFilters(null);
    }
  }, [currentUser]);

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(value.email));        
  }, [value.email])

  useEffect(() => {
    setValidFirstName(USER_REGEX.test(currentUser.name.firstName));
    setValidMiddleName(USER_REGEX.test(currentUser.name.middleName));
    setValidLastName(USER_REGEX.test(currentUser.name.lastName));
  }, [currentUser.name.firstName, currentUser.name.middleName, currentUser.name.lastName ])

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(currentUser.password));
    setValidMatch(currentUser.password === value.confirmpassword);
  }, [currentUser.password, value.confirmpassword])

  useEffect(() => {
    setValidMobile(MOBILE_REGEX.test(currentUser.mobileNo));        
  }, [currentUser.mobileNo])

  useEffect(() => {
    setValidEmpId(EMPID_REGEX.test(currentUser.employeeID));        
  }, [currentUser.employeeID])

  useEffect(() => {
    setValidLandline(LANDLINE_REGEX.test(currentUser.officeLandLine));        
  }, [currentUser.officeLandLine])

  useEffect(() => {
    setValidOfficeAdd(OFFICEADD_REGEX.test(currentUser.officeAddress));        
  }, [currentUser.officeAddress])

  const otherRoleArrayFunction = (office) => {
    let tempArray = [];
    
    // Check if Bo role is available for this office
    const officeData = Object.values(officedata)?.find(x => x.name === office);
    console.log(officeData)
    if (officeData && (!officeData.Bo || officeData.Bo.length === 0)) {
      tempArray.push("Bo");
    }
    
    // Only add store roles if this office is actually a store office
    if (isOfficeStoreOffice(office)) {
      const roleUsers = Object.values(storeoffices)?.find(x => x.storeoffice === office)?.roleUsers;
      for (let val of storeRoles) {
        if (!roleUsers?.[val]?.length && !tempArray.includes(val)) {
          tempArray.push(val);
        }
      }
    }
    
    return tempArray;
  };

  const onClickConfirm = (event) => {
    event.preventDefault();
    if (!editFields.length) return alert("Please Select atleast one Field to Edit.");
    
    let tempUser = structuredClone(currentUser);
    const editUser = structuredClone(Object.values(user)?.find(x => x.email === currentUser?.email));
    if (!editUser) return alert("Email Id doesnot exist");
    
    // Check office-based access control for non-admin users
    if (!hasAdminAccess()) {
      const currentUserOffices = getCurrentUserOffices();
      
      // Ensure current user has office assignments
      if (currentUserOffices.length === 0) {
        return alert("Access Denied: You don't have any office assignments. Please contact your administrator.");
      }
      
      const editUserOffices = [editUser.office?.mainCharge, ...(editUser.office?.additionalCharge || [])].filter(Boolean);
      
      // Check if there's any overlap between current user's offices and the user being edited
      const hasOfficeAccess = currentUserOffices.some(office => editUserOffices.includes(office));
      
      if (!hasOfficeAccess) {
        return alert(`Access Denied: This user does not belong to your office. You can only edit users from your office(s): ${currentUserOffices.join(', ')}`);
      }
    }
    
    setEditableUser(editUser);
    for (let key in tempUser) {
      tempUser[key] = editUser[key];
    }
    setCurrentUser(tempUser);
    setOriginalUser(tempUser);
    setFieldRender(true);
    alert(`You are editing user ${editUser.name.firstName} ${editUser.name.middleName} ${editUser.name.lastName}`);
  };

  const handleDeleteChip = (office, variable, key) => {
    let tempUser = structuredClone(currentUser);
    delete tempUser[key][office];
    setCurrentUser(tempUser);
  };
  
  const onChangeUserForm = (event) => {
    let tempData = structuredClone(currentUser);
    let tempValue = structuredClone(value);
    if (['firstName', 'middleName', 'lastName'].indexOf(event.target.name) > -1) {
      tempData.name[event.target.name] = event.target.value;
      setCurrentUser(tempData);
      return;
    }
    
    if (event.target.name === "confirmpassword") {
      tempValue = { ...tempValue, [event.target.name]: event.target.value };
      setValue(tempValue);
      return;
    }
    tempData = { ...tempData, [event.target.name]: event.target.value };
    setCurrentUser(tempData);
  };
  const onChangeUserForm2 = (event, newValue, name) => {
    if(name === 'mainCharge'){
      let tempUser = structuredClone(currentUser);
      delete tempUser.roles[tempUser.office.mainCharge];
      delete tempUser.designation[tempUser.office.mainCharge];
      delete tempUser.designationSuffix[tempUser.office.mainCharge];
      if( allData?.assets?.filter( x => (x.alloc_ofc === tempUser.office.mainCharge) && (x.cur_loc === "user")).length ){
        return alert(`Assets have not been handed over from ${tempUser.office.mainCharge} office`);
      }
      if( allData?.assets?.filter( x => (x.alloc_ofc === tempUser.office.mainCharge) && (x.cur_loc === "office"))?.length ){
        return alert(`BO Assets have not been handed over from ${tempUser.office.mainCharge} office`);
      }  
      if(newValue === null){
        tempUser.office.mainCharge = "";
      }else{
        tempUser.office.mainCharge = newValue;
      }      
      setCurrentUser(tempUser);
    } 
    if(name === 'additionalCharge'){
      let tempUser = structuredClone(currentUser);
      let oldOfficeKeys = tempUser?.office.additionalCharge;
      tempUser.office.additionalCharge = newValue;
      let officeKeys = tempUser.office.additionalCharge.filter(x=> x!=="");
      const removedOffice = oldOfficeKeys.concat(officeKeys).find(x => oldOfficeKeys.includes(x) && !officeKeys.includes(x))
        if(allData?.assets?.filter( x => (x.alloc_ofc === removedOffice) && (x.cur_loc === "user"))?.length ){
          return alert(`Assets have not been handed over from ${removedOffice} office`);
        }
        if( allData?.assets?.filter( x => (x.alloc_ofc === removedOffice ) && (x.cur_loc === "office"))?.length){
          return alert(`BO Assets have not been handed over from ${removedOffice} office`);
        }
      for(const key in tempUser.designation) {
        if(!(key in tempUser.office.additionalCharge) && !(key === tempUser.office.mainCharge)){
          delete tempUser.designation[key];
        }
      }
      for(const key in tempUser.designationSuffix) {
        if(!(key in tempUser.office.additionalCharge) && !(key === tempUser.office.mainCharge)){
          delete tempUser.designationSuffix[key];
        }
      }      
      for(const key in tempUser.roles) {
        if(!(key in tempUser.office.additionalCharge) && !(key === 'main') && !(key === tempUser.office.mainCharge)){
          delete tempUser.roles[key];
        }
      }
      setCurrentUser(tempUser); 
    }     
  
    if(name === 'selectFieldsToEdit'){
      setEditFields(newValue)
      // if(!event.target.value.length) setFieldRender(false)
    }

    if(name === 'selectMainRoles'){
      let tempUser = structuredClone(currentUser);
      tempUser.roles.main = ["user"].concat(newValue);
      setCurrentUser(tempUser);
    }

    if(name === "selectOtherRoles"){
      let tempUser = structuredClone(currentUser);
      tempUser.roles[Object.keys(newValue)[0]] = newValue[Object.keys(newValue)[0]];
      // We have to check whether Bo assets are to be set true here or in handover module.
      if(currentUser.roles[Object.keys(newValue)]?.includes("Bo") && !newValue[Object.keys(newValue)]?.includes("Bo") ){
        if( allData?.assets?.filter( x => (x.alloc_ofc === Object.keys(newValue)[0]) && (x.cur_loc === "office")).length){
          return alert("Bo Assets are still available with user.");
        }
      }
      if(currentUser.roles[Object.keys(newValue)]?.includes("ItemAdder_A") && !newValue[Object.keys(newValue)]?.includes("ItemAdder_A")){
        if( allData?.assets?.filter( x => (x.alloc_ofc === Object.keys(newValue)[0]) && (x.cur_loc === "store")).length){
          return alert("Store Assets are still available with user.");
        }       
      }
      setCurrentUser(tempUser)
    }
    let temp = {...value, [name]:newValue}
    setValue(temp);
  }

  const addDesgnSuffix = () => {
    //Check to ensure if both office and desig suffix are selected.
    if(["Select", "", undefined, null].some(x => [value.desgnSuffix, value.officeForSuffix].includes(x))) return alert("Please Select all values");
    let tempUser = structuredClone(currentUser);
    tempUser.designationSuffix[value.officeForSuffix] = value.desgnSuffix;  
    setCurrentUser(tempUser)
    let tempValue = {...value};
    tempValue.desgnSuffix=null;
    tempValue.officeForSuffix = null;
    setValue(tempValue)
  }
  const addDesign = () => {
    //Check to ensure if both office and designation are selected.
    if(["Select", "", undefined, null].some(x => [value.desig, value.officeForDesgn].includes(x))) return alert("Please Select all values");
    let tempUser = structuredClone(currentUser);
    tempUser.designation[value.officeForDesgn] = value.desig;
    const tempOffType = offices.find(x=> x.name === value.officeForDesgn)?.type
    if(officeType?.find(x=> x.type=== tempOffType)?.unitHead?.includes(value.desig)){
      if(tempUser?.roles[value.officeForDesgn]?.length){
      tempUser.roles[value.officeForDesgn].push("UnitHead")
      }else{
        tempUser.roles[value.officeForDesgn] = ["UnitHead"]
      }
    }
    tempUser.numSuffix[value.officeForDesgn] = calNumSuffix(userData, value.officeForDesgn, tempUser.designation);
    setCurrentUser(tempUser);
    let tempValue = {...value};
    tempValue.desig= null;
    tempValue.officeForDesgn = null;
    setValue(tempValue) 
  }  
  const onFinalSubmit = async (e) => {
    e.preventDefault();
    let tempUser = structuredClone(currentUser);
    if(Object.values(userData).filter(x=> x.email !== currentUser.email).map(x => x.mobileNo).includes(tempUser.mobileNo) && tempUser?.mobileNo !== originalUser?.mobileNo ){
      return alert("Mobile Number Already Exists. Please use different mobile number")
    }
    if(Object.values(userData).filter(x=> x.email !== currentUser.email).map(x => x.employeeID).includes(tempUser.employeeID) && tempUser?.employeeID !== originalUser?.employeeID){
      return alert("Employee ID Already Exists. Please use unique Employee ID")
    }
    let oldOfficeKeys = [editableuser?.office.mainCharge].concat(editableuser?.office.additionalCharge);
    let officeKeys = [currentUser.office.mainCharge].concat(currentUser.office.additionalCharge).filter(x=> x!=="");
    const deleteOffices = oldOfficeKeys.filter(x => !officeKeys.includes(x)).filter(x => x!=="");

    // Terminate pending requests for offices the user is leaving
    if (deleteOffices.length > 0) {
      console.log(`User ${currentUser.id} is leaving offices: ${deleteOffices.join(', ')}`);
      
      // Show alert about request termination
      alert(`User is being relieved from office(s): ${deleteOffices.join(', ')}. All pending requests will be automatically terminated.`);
      
      try {
        for (const office of deleteOffices) {
          console.log(`Terminating requests for user ${currentUser.id} in office ${office}`);
          const hooks = {
            getFilteredAssetRequests,
            updateAssetReq,
            getFilteredConsumableRequests,
            updateConsumableReq,
            getFilteredComplaints,
            updateComplaints
          };
          const terminationResults = await terminateUserRequests(currentUser.id, office, hooks);
          
          if (terminationResults.totalTerminated > 0) {
            console.log(`Successfully terminated ${terminationResults.totalTerminated} requests for office ${office}:`, terminationResults);
          }
          
          if (terminationResults.totalErrors > 0) {
            console.warn(`Encountered ${terminationResults.totalErrors} errors while terminating requests for office ${office}:`, terminationResults);
          }
        }
        
        // Show success message after termination
        alert(`Request termination completed. User has been successfully relieved from office(s): ${deleteOffices.join(', ')}`);
      } catch (error) {
        console.error('Error terminating user requests:', error);
        // Continue with user update even if termination fails
        alert(`Warning: Some pending requests could not be terminated automatically. Please contact administrator. Error: ${error.message}`);
      }
    }

    for(let value of officeKeys ){
      if(officeKeys.length){
        if(!(Object.keys(currentUser.designation).includes(value)) && ![null, ""].includes(value)){
          alert(`Please Assign designations to ${value} Office`)
          return
        }
        console.log(offices)
        const tempOffice = offices?.find(x => x.name === value);
        if (!tempOffice) return alert(`Office ${value} not showing in database`);
        
        // Check if there are any Bo/UnitHead role changes for this office
        const wasUnitHead = editableuser?.roles?.[value]?.includes("UnitHead");
        const isUnitHead = currentUser.roles[value]?.includes("UnitHead");
        const wasBo = editableuser?.roles?.[value]?.includes("Bo");
        const isBo = currentUser.roles[value]?.includes("Bo");
        
        // Only update office if there are actual role changes
        if (wasUnitHead !== isUnitHead || wasBo !== isBo) {
          let {_id, ...others} = structuredClone(tempOffice);
          
          if(isUnitHead) others["unitHead"] = currentUser.id;
          if(isBo) others["Bo"] = currentUser.id;
          
          if(wasUnitHead && !isUnitHead) {
            others["unitHead"] = "";
          }
          if(wasBo && !isBo) {
            others["Bo"] = "";
          }
          
          const resultOffice = await updateOffice(others);
        }
      }      
    }
    for(const val of deleteOffices) {
      if(deleteOffices?.length){
        delete tempUser.numSuffix[val];
        const tempOffice = offices.find(x => x.name === val);
        if (!tempOffice) {
          console.warn(`Office ${val} not found in offices list`);
          continue;
        }
        let {_id, ...others} = structuredClone(tempOffice);   
        if(others.unitHead){
          others.unitHead = "";
        }
        if(others.Bo){
          others.Bo = "";
        }
        const resOffice = await updateOffice(others);
      }      
    }
    
    for(let value of officeKeys){
      console.log("Entered For")
      //Check in the latest modified offices whether Store office present
      if(Object.values(storeOffices).map(x => x.storeoffice)?.includes(value)) {
        console.log("Entered If")
        //Check if store roles are identical in old and new user
        const reducedOriginalRole = editableuser?.roles[value]? (editableuser?.roles[value].map(x => [ "ItemAdder_A", "L1Approver_A", "L2Approver_A", "L1ReqApprover_A", "L2ReqApprover_A", "ItemAdder_C", "L1Approver_C", "L2Approver_C", "L1ReqApprover_C", "L2ReqApprover_C", "L1Support", "L2Support" ].includes(x))):[];
        console.log(reducedOriginalRole)
        const reducedLatestRole = currentUser?.roles[value]? currentUser?.roles[value]?.map(x => [      "ItemAdder_A", "L1Approver_A", "L2Approver_A", "L1ReqApprover_A", "L2ReqApprover_A", "ItemAdder_C",
        "L1Approver_C", "L2Approver_C", "L1ReqApprover_C", "L2ReqApprover_C", "L1Support", "L2Support"].includes(x)):[];
        console.log(reducedLatestRole)
        if(!areArraysIdentical(reducedOriginalRole, reducedLatestRole)) {
          console.log("Entered If Inside")
          console.log(value)
          console.log(originalUser)

          //If there is variation we create body object and update store office values.
          let body = {};
          let tempStoreObject = Object.values(structuredClone(storeOffices)).find(x => x.storeoffice === value);
          if(currentUser.roles[value]?.includes("ItemAdder_A")) tempStoreObject.roleUsers["ItemAdder_A"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L1Approver_A")) tempStoreObject.roleUsers["L1Approver_A"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L2Approver_A")) tempStoreObject.roleUsers["L2Approver_A"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L1ReqApprover_A")) tempStoreObject.roleUsers["L1ReqApprover_A"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L2ReqApprover_A")) tempStoreObject.roleUsers["L2ReqApprover_A"] = currentUser.id;
          if(currentUser.roles[value]?.includes("ItemAdder_C")) tempStoreObject.roleUsers["ItemAdder_C"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L1Approver_C")) tempStoreObject.roleUsers["L1Approver_C"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L2Approver_C")) tempStoreObject.roleUsers["L2Approver_C"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L1ReqApprover_C")) tempStoreObject.roleUsers["L1ReqApprover_C"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L2ReqApprover_C")) tempStoreObject.roleUsers["L2ReqApprover_C"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L1Support")) tempStoreObject.roleUsers["L1Support"] = currentUser.id;
          if(currentUser.roles[value]?.includes("L2Support")) tempStoreObject.roleUsers["L2Support"] = currentUser.id;

          if(originalUser.roles[value]?.includes("ItemAdder_A") && !currentUser.roles[value]?.includes("ItemAdder_A")) {
            tempStoreObject.roleUsers["ItemAdder_A"] = "";
          }
          if(originalUser.roles[value]?.includes("L1Approver_A") && !currentUser.roles[value]?.includes("L1Approver_A")) {
            tempStoreObject.roleUsers["L1Approver_A"] = "";
          }
          if(originalUser.roles[value]?.includes("L2Approver_A") && !currentUser.roles[value]?.includes("L2Approver_A")) {
            tempStoreObject.roleUsers["L2Approver_A"] = "";
          }
          if(originalUser.roles[value]?.includes("L1ReqApprover_A") && !currentUser.roles[value]?.includes("L1ReqApprover_A")) {
            tempStoreObject.roleUsers["L1ReqApprover_A"] = "";
          }
          if(originalUser.roles[value]?.includes("L2ReqApprover_A") && !currentUser.roles[value]?.includes("L2ReqApprover_A")) {
            tempStoreObject.roleUsers["L2ReqApprover_A"] = "";
          }
          if(originalUser.roles[value]?.includes("ItemAdder_C") && !currentUser.roles[value]?.includes("ItemAdder_C")) {
            tempStoreObject.roleUsers["ItemAdder_C"] = "";
          }
          if(originalUser.roles[value]?.includes("L1Approver_C") && !currentUser.roles[value]?.includes("L1Approver_C")) {
            tempStoreObject.roleUsers["L1Approver_C"] = "";
          }
          if(originalUser.roles[value]?.includes("L2Approver_C") && !currentUser.roles[value]?.includes("L2Approver_C")) {
            tempStoreObject.roleUsers["L2Approver_C"] = "";
          }
          if(originalUser.roles[value]?.includes("L1ReqApprover_C") && !currentUser.roles[value]?.includes("L1ReqApprover_C")) {
            tempStoreObject.roleUsers["L1ReqApprover_C"] = "";
          }
          if(originalUser.roles[value]?.includes("L2ReqApprover_C") && !currentUser.roles[value]?.includes("L2ReqApprover_C")) {
            tempStoreObject.roleUsers["L2ReqApprover_C"] = "";
          }
          if(originalUser.roles[value]?.includes("L1Support") && !currentUser.roles[value]?.includes("L1Support")) {
            tempStoreObject.roleUsers["L1Support"] = "";
          }
          if(originalUser.roles[value]?.includes("L2Support") && !currentUser.roles[value]?.includes("L2Support")) {
            tempStoreObject.roleUsers["L2Support"] = "";
          }

          body["id"] = tempStoreObject.id;
          body["roleUsers"] = tempStoreObject.roleUsers;
          const resUpdate = await updateStoreOffice(body);
        }        
      }
    }  
    const result = await updateUser(tempUser);
    alert(`User has been updated`)
    setCurrentUser(initialUserState);
    setFieldRender(false);
    setEditFields([])
    setValue({})
  }

  // if(finalDesigValue.length) setFinalDesigValue([`${currentUser.designation} (${})`])
const basicInfoArray = ["All", "Name", "Password", "Contact Number", "Employee ID", "Office Address"];

  useEffect(()=>{
    if(officedata){
        const finalOfficeData = Object.values(officedata)
        setOffices(finalOfficeData)       
    }
  },[officedata])

  useEffect(()=>{
    if(officetype){
        const finalOfficeType= Object.values(officetype)
        setOfficeType(finalOfficeType)       
    }
  },[officetype])

  useEffect(()=>{
    if(storeoffices){
        setStoreOffices(Object.values(storeoffices))
    }
  },[storeoffices])

  useEffect(()=>{
    if(designation){
        setDesig(Object.values(designation))
    }
  },[designation])

  useEffect(()=>{
    if(user){
      setUserData(user)
    }
  },[user])

  return (
    <>
      <FilteredAssetsFetcher filters={filters} onDataFetched={setAllData} />
      
      <EditUser>
        <HeadingField>Edit User</HeadingField>
      </EditUser>
      
      <form onSubmit={onClickConfirm}>
        <FlexWrapper>
          <UserEmailWrapper>
            <TextField
              id="outlined-basic"
              ref={userRef}
              name="email"
              onChange={(event, newValue) => onChangeUserForm(event, newValue)}
              label="Enter Email"
              value={currentUser?.email}
              variant="outlined"
              onFocus={() => setEmailFocus(true)}
              onBlur={() => setEmailFocus(false)}
              sx={{ backgroundColor: "white" }}
            />
            {emailFocus && !validEmail ? (
              <ValidationTextDiv>Please Enter Valid Email</ValidationTextDiv>
            ) : null}
          </UserEmailWrapper>
          
          <EditOptionsWrapper>
            <Autocomplete
              multiple
              id="selectFieldsToEdit"
              sx={{ minWidth: "200px", maxWidth: "800px" }}
              onChange={(event, newValue) => onChangeUserForm2(event, newValue, 'selectFieldsToEdit')}
              value={editFields}
              options={editFields.includes("All") ? ["All"] : Fields}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Select Fields to Edit" placeholder="Edit Fields" />
              )}
            />
          </EditOptionsWrapper>
        </FlexWrapper>

        <EditFieldButton type="submit">Confirm</EditFieldButton>
      </form>
      {(fieldRender && editFields?.length) && (
        <form style={{ margin: "15px" }} onSubmit={onFinalSubmit}>
          {editFields?.some(x => basicInfoArray.includes(x)) && hasAdminAccess() && (
            <SubHeadingField>Basic Info</SubHeadingField>
          )}
          <Adduserformcont>
            {(["Name", "All"].some(x => editFields?.includes(x))) && hasAdminAccess() && (
              <>
                <LabelInputWrapper>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    ref={userRef}
                    name="firstName"
                    onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                    label="First Name"
                    value={currentUser?.name?.firstName}
                    variant="outlined"
                    onFocus={() => setFirstNameFocus(true)}
                    onBlur={() => setFirstNameFocus(false)}
                    sx={{ backgroundColor: "white" }}
                  />
                  {firstNameFocus && !validFirstName ? (
                    <div>Please Enter Valid First Name</div>
                  ) : null}
                </LabelInputWrapper>
            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='middleName'
                onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                label="Middle Name"
                value={currentUser?.name?.middleName}
                variant="outlined"
                onFocus={() => setMiddleNameFocus(true)}
                onBlur={() => setMiddleNameFocus(false)}
                sx={{backgroundColor:"white"}}
              />    
              {middleNameFocus && !validMiddleName ? <div>Please Enter Valid Middle Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='lastName'
                onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                label="Last Name"
                value={currentUser?.name?.lastName}
                variant="outlined"
                onFocus={() => setLastNameFocus(true)}
                onBlur={() => setLastNameFocus(false)}
                sx={{backgroundColor:"white"}}
              />
              {lastNameFocus && !validLastName ? <div>Please Enter Valid Last Name</div> : null}
            </LabelInputWrapper>
              </>
            )}
                 
            {(["Password","All"].some(x => editFields?.includes(x))) && hasAdminAccess() && (
              <>
                <LabelInputWrapper>
              <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='password'
                  type={showPassword? "text": "password"}
                  onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                  label="Password"
                  value={currentUser?.password}
                  variant="outlined"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                  sx={{backgroundColor:"white"}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePasswordVisibility}>
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  />               
                {pwdFocus && !validPwd ?<div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='confirmpassword'
                  type='password'
                  onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                  label="Confirm Password"
                  value={value.confirmpassword}
                  variant="outlined"
                  onFocus={() => setMatchFocus(true)}
                  onBlur={() => setMatchFocus(false)}
                  sx={{backgroundColor:"white"}}
              />
                {matchFocus && !validMatch ? <div>Password Error Message</div> : null}
            </LabelInputWrapper>
              </>
            )}

            {(["Contact Number","All"].some(x => editFields?.includes(x))) && hasAdminAccess() && (
              <>
                <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='mobileNo'
                type='text'
                onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                label="Enter Mobile Number"
                value={currentUser.mobileNo}
                variant="outlined"
                onFocus={() => setMobileFocus(true)}
                onBlur={() => setMobileFocus(false)}
                sx={{backgroundColor:"white"}}
                />             
              {mobileFocus && !validMobile ? <div>Enter Valid Mobile Number</div>: null}
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='officeLandLine'
                type='text'
                onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                label="Enter Office Landline"
                value={currentUser?.officeLandLine}
                variant="outlined"
                onFocus={() => setLandlineFocus(true)}
                onBlur={() => setLandlineFocus(false)}
                sx={{backgroundColor:"white"}}
              />
              {landlineFocus && !validLandline ? <div>Enter Valid Landline Number</div> : null}
            </LabelInputWrapper>
            </>
            )}

            {(["Employee ID","All"].some(x => editFields?.includes(x))) && hasAdminAccess() && <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                ref={userRef}
                name='employeeID'
                type='text'
                onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                label="Enter Employee ID"
                value={currentUser?.employeeID}
                variant="outlined"
                onFocus={() => setEmpIdFocus(true)}
                onBlur={() => setEmpIdFocus(false)}
                sx={{backgroundColor:"white"}}
              /> 
              {empIDFocus && !validEmpId ? <div>Enter Valid Employee ID</div>: null}
            </LabelInputWrapper>}          

              {(["Office Address","All"].some(x => editFields?.includes(x))) && hasAdminAccess() && <LabelInputWrapper>
                <TextField
                    id="outlined-basic"
                    size='small'
                    ref={userRef}
                    name='officeAddress'
                    type='text'
                    onChange={(event, newValue) => onChangeUserForm(event, newValue)}
                    label="Enter Office Address"
                    value={currentUser?.officeAddress}
                    variant="outlined"
                    onFocus={() => setOfficeAddFocus(true)}
                    onBlur={() => setOfficeAddFocus(false)}
                    sx={{backgroundColor:"white"}}
                />                
                {officeAddFocus && !validOfficeAdd ? <div>Enter Valid Office Address</div>: null}
            </LabelInputWrapper>}
            
            </Adduserformcont>
            {(["Office","All"].some(x => editFields?.includes(x))) && hasAdminAccess() && (
              <>
                <SubHeadingField>Office</SubHeadingField>
            <Chrg>
            <MainChrgWrapper name="mainCharge">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                size='small'
                value={currentUser?.office?.mainCharge}
                onChange={(event, newValue) => onChangeUserForm2(event, newValue, "mainCharge")}
                options={offices?.map((item)=>item.name).filter( x => !currentUser.office.additionalCharge.includes(x))}
                sx={{ minWidth: "200px", backgroundColor:"white" }}
                renderInput={(params) => <TextField {...params} label={"Main Charge Office"} />}
              />
          </MainChrgWrapper>

        <AddChrgWrapper>
        <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            size='small'
            onChange={(event, newValue) => onChangeUserForm2(event, newValue, "additionalCharge")}
            value={currentUser?.office?.additionalCharge}
            options={offices?.map((item)=>item.name).filter(x => x!==currentUser.office.mainCharge)}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
            {option}
            </li>
            )}
            renderInput={(params) => (
          <TextField {...params} label="Select Additional Charge Offices" placeholder="Offices" />          
          )}
          sx={{ minWidth: "300px", backgroundColor:"white" }}
        />
        </AddChrgWrapper>
        </Chrg>
        </>
      )}
        {(editFields?.includes("Designation") || editFields?.includes("All") || editFields?.includes("Office")) && hasAdminAccess() && (
          <>
            <SubHeadingField>Designation (Office Wise)</SubHeadingField>   
      <DesignationWrapper> 
      <LabelInputWrapperSuffix name="officeForDesgn">
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={value?.officeForDesgn}
          onChange={(event, newValue) => onChangeUserForm2(event, newValue, "officeForDesgn")}
          options={([currentUser.office.mainCharge]?.concat(currentUser.office.additionalCharge))?.filter(x => ! Object.keys(currentUser.designation).includes(x)).map(item => item)}
          sx={{ minWidth: "200px", backgroundColor:"white" }}
          renderInput={(params) => <TextField {...params} label={"Office for Designation"} />}
        />               
      </LabelInputWrapperSuffix>
      <LabelInputWrapperSuffix name="desig" >
        <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={value?.desig}
            onChange={(event, newValue) => onChangeUserForm2(event, newValue, "desig")}
            options={desig.map(item => item.name)}
            sx={{ minWidth: "200px", backgroundColor:"white" }}
            renderInput={(params) => <TextField {...params} label={"Designation"} />}
          />           
      </LabelInputWrapperSuffix>
      <EditFieldButton type="button" onClick={(e)=>addDesign(e)}>Add Desig</EditFieldButton>
      </DesignationWrapper>
      <DesignationWithOffice>
        <Typography variant="subtitle1" mr={2}>
          Office Wise Designations:
        </Typography>
        <Stack direction="row" spacing={1} sx={{border:'1px solid grey', padding: '10px', borderRadius: '8px', minWidth:"412px", minHeight:"32px", backgroundColor:"white"}}>
          {Object.entries(currentUser.designation).map((item,index)=>
            <Chip key={index} label={`${item[0]} [${item[1]}]`} sx={{minHeight:"28px"}} onDelete={() => handleDeleteChip(item[0], item[1], "designation")} />)
          }
        </Stack>
      </DesignationWithOffice> 

      <SubHeadingField>Designation Suffix (Office Wise)</SubHeadingField>
      <SuffixWrapper>      
        <LabelInputWrapperSuffix name="officeForSuffix">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={value?.officeForSuffix}
            onChange={(event, newValue) => onChangeUserForm2(event, newValue, "officeForSuffix")}
            options={([currentUser.office.mainCharge]?.concat(currentUser.office.additionalCharge))?.filter(x => ! Object.keys(currentUser.designationSuffix).includes(x)).map(item => item)}
            sx={{ minWidth: "200px", backgroundColor:"white" }}
            renderInput={(params) => <TextField {...params} label={"Office for Desig Suffix"} />}
          />  
        </LabelInputWrapperSuffix>
      <LabelInputWrapperSuffix name="desgnSuffix" >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={value?.desgnSuffix}
          onChange={(event, newValue) => onChangeUserForm2(event, newValue, "desgnSuffix")}
          options={Object.values(designationsuffix)?.map(item => item.name)}
          sx={{ minWidth: "200px", backgroundColor:"white" }}
          renderInput={(params) => <TextField {...params} label={"Designation Suffix"} />}
        />  
      </LabelInputWrapperSuffix>
      <EditFieldButton type="button" onClick={(e)=>addDesgnSuffix(e)}>Add Suffix</EditFieldButton>
      </SuffixWrapper>      
      <DesignationWithOffice>
        <Typography variant="subtitle1" mr={2}>
          Office Wise Desig Suffix:
        </Typography>
        <Stack direction="row" spacing={1} sx={{border:'1px solid grey', padding: '10px', borderRadius: '8px', minWidth:"412px", minHeight:"32px", backgroundColor:"white"}}>
          {Object.entries(currentUser.designationSuffix).map((item,index)=>
            <Chip key={index} label={`${item[0]} (${item[1]})`} sx={{minHeight:"28px"}} onDelete={() => handleDeleteChip(item[0], item[1], "designationSuffix")} />)
          }
        </Stack>
      </DesignationWithOffice>
      </>
    )}
      {(editFields?.includes("Roles") || editFields?.includes("All") || editFields?.includes("Office")) && (
        <>
          {/* Main Roles section - only visible to Admin/SuperAdmin */}
          {hasAdminAccess() && (
            <>
              <SubHeadingField>Main Roles (Other than User)</SubHeadingField>
              <RolesWrapper>
                <MainRolesWrapper>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    size='small'
                    onChange={(event, newValue) => onChangeUserForm2(event, newValue, "selectMainRoles")}
                    value={currentUser?.roles?.main.filter(x => x !== "user")}
                    options={mainRoles}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Main Roles" placeholder="Roles" />          
                    )}
                    sx={{ minWidth: "300px", backgroundColor:"white" }}
                  />
                </MainRolesWrapper>
              </RolesWrapper>
            </>
          )} 

          {/* Other Roles section - available to all users (only section for non-admin users) */}
          <SubHeadingField>Other Roles (Office Wise)</SubHeadingField>
        <OfficeWiseRolesWrapper>
        {(Object.keys(currentUser.designation))?.map((item,index) => 
        <OfficeWiseRolesSubWrapper>
          <Typography variant="subtitle1" mr={2}>
          {`${item}:`}
          </Typography>

          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            size='small'
            onChange={(event, newValue) => onChangeUserForm2(event, {[item]:newValue}, "selectOtherRoles")}
            value={currentUser?.roles[item]}
            options={otherRoleArrayFunction(item)}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
            {option}
            </li>
            )}
            renderInput={(params) => (
            <TextField {...params} label="Select Other Roles" placeholder="Roles" />          
            )}
            sx={{ minWidth: "300px", backgroundColor:"white" }}
          />
        </OfficeWiseRolesSubWrapper>)}

        </OfficeWiseRolesWrapper>
        </>
      )}
          <EditFieldButton type="submit">Final Submit</EditFieldButton>
        </form>
      )}
    </>
  );
};

export default EditUsers;